// Captcha.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./Captcha.css";
import RefreshIcon from "../Images/refreshcaptcha.png";

const apiUrl = process.env.REACT_APP_BACKEND_URL;
// console.log('APIIIIIIII',apiUrl)

function Captcha({ onCaptchaSolved }) {
  const [captcha, setCaptcha] = useState({ id:"", question: '', answer: 0 });
  const [userAnswer, setUserAnswer] = useState('');

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const fetchCaptcha = async () => {
    const response = await axios.get(`${apiUrl}api/v1/business/fetchCaptcha`);
    const captcha = response.data;

    localStorage.setItem(
      "captcha",
      JSON.stringify({ id: captcha.id, question: captcha.question })
    );

    setCaptcha({id:captcha?.id, question: captcha.question, answer:0});
    setUserAnswer('');
    onCaptchaSolved("");
  };

  const handleChange = (e) => {
    setUserAnswer(e.target.value);
    onCaptchaSolved(e.target.value);
  };

  const handleKeyPress = (e) => {
    // Allow only numeric input
    if (e.key && !/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };
  
  return (
    <div>
      <p className='' style={{textAlign:'left'}}>What is : {captcha.question}</p>
    <div className='inputbuttoncontainer'>
    <input
        type="text"
        value={userAnswer}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        placeholder="Input your answer"
        className='captchainput'
        maxLength={2}
      />
      {/* <button onClick={fetchCaptcha}>Refresh CAPTCHA</button> */}
      <button className='refresscaptchabtn' type='button' onClick={fetchCaptcha}>
        <img className='refreshicon' src={RefreshIcon} alt="Refresh CAPTCHA" /> Refresh
      </button>

    </div>
    </div>
  );
}

export default Captcha;
